<template>
  <v-card elevation="0" class="my-2">
    <v-container class="ma-0 pa-0 px-2" v-if="calendar">
      <v-row no-gutters align="center" justify="space-around">
        <v-col no-gutters xl="9" lg="9" md="9" sm="9" cols="9">
          <div class="title">{{ calendar.professional }}</div>
          <div class="subtitle-2 mb-2">{{ `${calendar.entity} ${calendar.document}` }}</div>
          <v-btn text @click="addRemoveFavorite" :loading="favoriteLoading">
            <v-icon left size="28"
              :color="calendar.professionalIsFavorite ? 'accent' : 'primary'" class="mr-3">
              {{ (calendar.professionalIsFavorite) ?
                  'mdi-account-heart' :
                  'mdi-account-heart-outline'
              }}
            </v-icon>
            Meus Médicos
          </v-btn>
        </v-col>
        <v-col no-gutters xl="3" lg="3" md="3" sm="3" cols="3">
          <share-professional :professionalId="calendar.professionalId"
            :calendarId="calendar.calendarId" />

          <v-list-item-avatar :size="($vuetify.breakpoint.xsOnly) ? 52 : 72" color="blue">
            <v-img :src="calendar.professionalAvatar"></v-img>
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import bus from '@/plugins/eventBus';
import ShareProfessional from '@/components/general/ShareProfessional';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    calendar: null,
    favoriteLoading: false,
  }),
  computed: {
    user() {
      return this.$store.getters['auth/getUser'];
    },
  },
  created() {
    this.calendar = this.value;
  },
  watch: {
    value(vl) {
      this.calendar = vl;
    },
  },
  methods: {
    addRemoveFavorite() {
      const method = (this.calendar.professionalIsFavorite) ? 'patientProfessionals/remove' : 'patientProfessionals/add';
      this.favoriteLoading = true;
      this.$store
        .dispatch(method, { patientId: this.user.id, professionalId: this.calendar.professionalId })
        .then(() => {
          this.calendar.professionalIsFavorite = !this.calendar.professionalIsFavorite;
        })
        .catch(() => {
          const msg = (this.calendar.professionalIsFavorite)
            ? 'Erro ao remover o médico dos favoritos'
            : 'Erro ao adicionar o médico dos favoritos';
          bus.$emit('message', {
            message: msg,
            type: 'error',
          });
        })
        .finally(() => {
          this.favoriteLoading = false;
        });
    },
  },
  components: {
    ShareProfessional,
  },
};
</script>
